
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.973 2.25c-.94.149-1.713.767-1.971 1.894v9.646c-.008.94 1.203 1.964 2.01 1.97h13.884c1.117.003 2.11-1.115 2.11-2.052V4.3c-.008-.999-1.11-2.047-2.012-2.05zM1.19 3.401h.01l-.008.01zm.776 0l14.14.004L9.1 9.538zm14.896.004h.01v.01zM1.19 4.071l4.795 4.123-4.795 5.62zm15.686.004l.05 9.748-4.847-5.55zM6.746 8.847l2.027 1.744a.506.506 0 00.664-.002l1.891-1.654 4.94 5.652H1.85z","font-family":"sans-serif","opacity":".99","overflow":"visible","paint-order":"markers stroke fill"}})])
          )
        }
      }
    